export enum FeatureFlag {
  FEATURE_B2B_ACCESS,
}
